export { CaptchaComponent } from './captcha/captcha.component';
